export enum SmartCreateFeedbackVariant {
	ROVO = 'rovo',
	CREATE_WITH_ROVO = 'create-with-rovo', // Confluence
	CREATE_WITH_ROVO_FROM_JIRA = 'create-with-rovo-from-jira', // Jira
	REMIX = 'remix',
	SLIDES = 'slides',
}

export interface SmartCreateFeedbackProps {
	/**
	 * The variant of the SmartCreateFeedback component (either "Rovo" or "Create with Rovo").
	 */
	variant?: SmartCreateFeedbackVariant;

	/**
	 * Callback function to close the SmartCreateFeedback component.
	 */
	onClose: () => void;

	/**
	 * Callback function to submit the feedback.
	 */
	onSubmit: () => void;

	/**
	 * The tenant ID (cloud ID) for the feedback context.
	 */
	tenantId?: string;

	/**
	 * Additional fields to log in thefeedback context.  This will be saved, so do not share UGC here.
	 */
	additionalFields?: object;
}
